import React, { Fragment } from 'react'
import { Col, Row } from 'reactstrap'
import Skeleton from 'react-loading-skeleton';

const LoadingComponent = function (props) {
    return (
        <Fragment>
            <Row>
                <Col md="6">
                    <h2>
                        <Skeleton />
                    </h2>
                    <h4>
                        <Skeleton width={200} />
                    </h4>
                </Col>
                <Col md="6">
                    <h1>
                        <Skeleton height={100} />
                    </h1>
                </Col>
            </Row>
            <hr />
            <Row>
                <Col md="1">
                    <Skeleton height={80} />
                </Col>
                <Col md="5">
                    <Skeleton height={80} />
                </Col>
                <Col md="3">
                    <Skeleton height={80} />
                </Col>
                <Col md="3">
                    <Skeleton height={80} />
                </Col>
            </Row>
            <Row className="mt-3">
                <Col md="1">
                    <Skeleton />
                </Col>
                <Col md="5">
                    <Skeleton />
                </Col>
                <Col md="3">
                    <Skeleton />
                </Col>
                <Col md="3">
                    <Skeleton />
                </Col>
            </Row>
        </Fragment>
    );
};

export default LoadingComponent;
